import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProductComponent } from './product.component';
import { ProductDetailComponent } from './components/product-detail/product-detail.component';
import { SuggestedProductsComponent } from './components/suggested-products/suggested-products.component';
import { RecommendedProductsComponent } from './components/recommended-products/recommended-products/recommended-products.component';

const routes: Routes = [
  {
    path: 'listing/:categoryid', component: ProductComponent
  },
  {
    path: 'detail/:productid', component: ProductDetailComponent
  },
  { path: 'suggested-products', component: SuggestedProductsComponent },
  ,
  { path: 'recommended-products', component: RecommendedProductsComponent },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProductRoutingModule { }
